export interface TopBarProps {
  onToggleCatalog?: () => void;
  onResetScene: () => void;
  /** Stubs in v1 — buttons rendered but disabled (no save/load persistence yet). */
}

/**
 * Top action bar. Reset is the only live command in v1; save/load/AR/inspiration
 * are placeholders so the layout matches the Blazor reference and so the wiring
 * exists when the persistence story is decided.
 */
export function TopBar({ onToggleCatalog, onResetScene }: TopBarProps) {
  return (
    <div className="sd-topbar">
      {onToggleCatalog && (
        <button
          type="button"
          className="sd-topbar__btn sd-topbar__btn--hamburger"
          onClick={onToggleCatalog}
          aria-label="Toggle catalog"
          title="Catalog"
        >
          <span aria-hidden="true">☰</span>
        </button>
      )}
      <div className="sd-topbar__group">
        <button type="button" className="sd-topbar__btn" disabled title="Save (coming soon)">💾 Save</button>
        <button type="button" className="sd-topbar__btn" disabled title="Load (coming soon)">📂 Load</button>
        <button type="button" className="sd-topbar__btn" disabled title="Inspiration (coming soon)">✨ Inspiration</button>
        <button type="button" className="sd-topbar__btn" disabled title="AR export (coming soon)">📱 AR</button>
      </div>
      <div className="sd-topbar__spacer" />
      <button type="button" className="sd-topbar__btn sd-topbar__btn--danger" onClick={onResetScene} title="Reset the whole scene">
        ⟳ Reset
      </button>
    </div>
  );
}
